import React from "react";
import "./profile.css";

const Profile = () => {

    const username = localStorage.getItem("username");
    
    const user = username === "admin@gmail.com" ? {
        name: "Admin ",
        email: "admin@gmail.com",
        phone: "9876543210",
        status: "Active",
        designation: "Admin",
    } : {
        name: "User",
        email: "user@gmail.com",
        phone: "9876543210",
        status: "Active",
        designation: "User",
    };
  return (
    <div className="profile-container">
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-avatar">
            {user.name.charAt(0)}
          </div>
          <div className="profile-basic">
            <h2>{user.name}</h2>
            <p className="designation">{user.designation}</p>
            <span className={`profile-status ${user.status.toLowerCase()}`}>
              {user.status}
            </span>
          </div>
        </div>

        <div className="profile-details">
          <div className="detail-row">
            <label>Email</label>
            <p>{user.email}</p>
          </div>

          <div className="detail-row">
            <label>Phone</label>
            <p>{user.phone}</p>
          </div>

          <div className="detail-row">
            <label>Role</label>
            <p>User</p>
          </div>
        </div>

        <div className="profile-actions">
          <button className="edit-profile-btn">Edit Profile</button>
          <button className="change-password-btn">Change Password</button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
